// The fields an editor changes in Review, per language.
const textOf = version => ({
  title: version?.title || '',
  content: version?.content || '',
  keytakes: version?.keytakes || '',
  summary: (version?.summary || []).filter(Boolean),
  metaDescription: version?.metaDescription || '',
  imageAltText: version?.imageAltText || '',
  slug: version?.slug || '',
  keywords: (version?.keywords || []).filter(Boolean),
});

// The draft's main language first, then each translation: one tab each.
export const versionsFromArticle = article =>
  [article, ...(article?.multilang || [])]
    .filter(Boolean)
    .map(version => ({language: version.language, ...textOf(version)}));

// What approveNewsDraft gets. Nothing when the editor changed nothing: the
// draft publishes as written, which is how "published without changes" is
// counted. Otherwise the whole article with the edits in it, since `data`
// replaces the draft. Companies go only when the editor changed them;
// without them the backend links the companies it finds in the text.
export const approvalData = ({article, values, edited, companiesTouched}) => {
  if (!edited && !companiesTouched) return undefined;
  const [main, ...translations] = values.versions;
  const data = {
    ...article,
    ...textOf(main),
    // One picture for every language, so it sits on the article only.
    featuredImage: values.featuredImage || article.featuredImage,
    type: values.type,
    tag: values.tag,
    multilang: (article.multilang || []).map((translation, i) => ({
      ...translation,
      ...textOf(translations[i]),
    })),
  };
  if (companiesTouched) data.instrumentIds = values.instrumentIds || [];
  else delete data.instrumentIds;
  return data;
};

// The listed company that best matches one the writing tool named: the same
// ticker, or else the first result for its name.
export const matchMention = (mention, results) =>
  results.find(
    option =>
      mention.ticker &&
      option?.ticker?.toUpperCase() === mention.ticker.toUpperCase(),
  ) || results[0];

// "ThisDay", "ThisDay and Punch", "ThisDay, Punch and BusinessDay".
export const nameList = names => {
  if (!names?.length) return '';
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};
